import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Check, AlertTriangle, Star, Loader2 } from 'lucide-react';

export default function SubscriptionResult() {
  const [status, setStatus] = useState<'loading' | 'success' | 'failed'>('loading');
  const [message, setMessage] = useState('');
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      return;
    }

    const params = new URLSearchParams(location.search);
    const subStatus = params.get('status');
    const serverMessage = params.get('message');

    if (subStatus === 'success') {
      setStatus('success');
      setMessage(serverMessage || '프로 플랜 구독이 성공적으로 시작되었습니다!');
    } else {
      setStatus('failed');
      setMessage(serverMessage || '구독 처리에 실패했습니다. 다시 시도해주세요.');
    }

    window.history.replaceState({}, '', window.location.pathname);

  }, [location.search]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <Loader2 className="animate-spin h-12 w-12 text-blue-600 mx-auto" />
          <h2 className="mt-6 text-xl font-semibold text-gray-900">결과 확인 중...</h2>
          <p className="mt-2 text-sm text-gray-600">페이지를 잠시 후에 새로고침합니다.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white rounded-xl shadow-2xl p-8 md:p-10">
        {status === 'success' ? (
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
              <Check className="h-6 w-6 text-green-600" />
            </div>
            <h2 className="mt-6 text-xl font-semibold text-gray-900">구독이 완료되었습니다!</h2>
            <div className="mt-4 p-4 bg-blue-50 rounded-lg">
                <div className="flex justify-center items-center text-blue-800">
                    <Star className="w-5 h-5 mr-1 text-yellow-500" />
                    <p className="font-semibold">이제 프로 플랜의 모든 기능을 이용할 수 있습니다.</p>
                </div>
            </div>
            {message && <p className="mt-4 text-sm text-gray-600">{message}</p>}
            <div className="mt-8">
              <Link
                to="/dashboard"
                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700"
              >
                대시보드로 이동
              </Link>
            </div>
          </div>
        ) : (
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <AlertTriangle className="h-6 w-6 text-red-600" />
            </div>
            <h2 className="mt-6 text-xl font-semibold text-gray-900">구독 처리 실패</h2>
            {message && <p className="mt-2 text-sm text-gray-700">{message}</p>}
            <div className="mt-8">
              <Link
                to="/dashboard/billing"
                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-base font-medium text-white bg-gray-600 hover:bg-gray-700"
              >
                결제 페이지로 돌아가기
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}